/* ConnectionItem renders nothing in place of a missing subtitle, so a statement row (no
   subtitle) is visibly shorter than a connection row (has one). This min-height ensures they are equal. */
.sourceItem {
  min-height: var(--sizes-spacing-17);
}
